import React from "react";
import "./customerInvestPolicy.scss";
import { UmbracoProvider } from "../../components/Umbraco/UmbracoContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import FillingQuestions from "./components/FillingQuestions";
import Layout from "../../Layout";
import * as Constants from "../../utils/constants";

const SITE_KEY = Constants.RECAPTCHA_CURRENT_ENV;

export default function CustomerInvestPolicy() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={SITE_KEY}
      useEnterprise="true"
      scriptProps={{ async: true }}
    >
      <UmbracoProvider umbracoUrl="/api/home/GetPage/CustomerInvestPolicy/CustomerInvestPolicyPage">
        <Layout>
          <FillingQuestions />
        </Layout>
      </UmbracoProvider>
    </GoogleReCaptchaProvider>
  );
}
